import React, { useState, useEffect } from "react";
import { Button, Container } from "react-bootstrap";
import { Table, type TableColumnsType, type TableProps } from "antd";
import { Switch } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../Api/Config";

const label = { inputProps: { "aria-label": "Size switch demo" } };

interface DataType {
  key: React.Key;
  sno: string;
  position: string;
  image: string;
  link: string;
  couponCode: string;
  discount: string;
  active: boolean;
  action: string;
}

const OfferBannerMain = () => {
  const [data, setData] = useState<DataType[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/api/banner/offerBanners`
        );
        const banners: DataType[] = response.data.banners.map(
          (banner: any, index: number) => ({
            key: banner._id,
            sno: (index + 1).toString(),
            position: banner.position,
            image: `${API_URL}/public/images/${banner.image}`,
            link: banner.link,
            couponCode: banner.couponCode || "-",
            discount: banner.discount ? `${banner.discount}%` : "-",
            active: banner.actionButton,
            action: "",
          })
        );
        setData(banners);
      } catch (error) {
        console.error("Error fetching banners:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBanners();
  }, []);

  const handleEditProduct = (record: DataType) => {
  
    navigate(`/edit-banner/offerBanners/${record.key}`);
  };
  const handleActiveToggle = async (record: DataType) => {
    const updatedActiveStatus = !record.active;
    try {
      await axios.patch(
        `${API_URL}/api/banner/offerBanners/${record.key}`,
        {
          actionButton: updatedActiveStatus,
        },{
          headers:{
            Authorization:`Bearer ${localStorage.getItem("dashtoken")}`
          }
        }
      );
      setData((prevData) =>
        prevData.map((item) =>
          item.key === record.key ? { ...item, active: updatedActiveStatus } : item
        )
      );
    } catch (error) {
      console.error("Error updating banner status:", error);
    }
  };

  const columns: TableColumnsType<DataType> = [
    { title: "S. No", dataIndex: "sno" },
    { title: "Position", dataIndex: "position" },
    {
      title: "Image",
      dataIndex: "image",
      render: (image: string) => (
        <div className="offer-img">
          <img src={image} className="img-fluid" alt="img" />
        </div>
      ),
    },
    {
      title: "Link",
      dataIndex: "link",
      render: (link: string) => (
        <a href={link} target="_blank" rel="noopener noreferrer">
          {link}
        </a>
      ),
    },
    {
      title: "Coupon Code",
      dataIndex: "couponCode",
    },
    {
      title: "Discount",
      dataIndex: "discount",
    },
    {
      title: "Active",
      dataIndex: "active",
      render: (_, record) => (
        <Switch
          checked={record.active}
          onChange={() => handleActiveToggle(record)}
          size="small"
        />
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_, record) => (
        <div className="d-flex justify-content-start">
          <span ><i onClick={() => handleEditProduct(record)} className="fi fi-rs-pencil edit"></i></span>
        </div>
      ),
    },
  ];

  const rowSelection: TableProps<DataType>["rowSelection"] = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys: React.Key[]) => {
      setSelectedRowKeys(newSelectedRowKeys);
    },
  };

  const handleDeleteSelectedBanners = async () => {
    try {
      await Promise.all(
        selectedRowKeys.map(async (key) => {
          await axios.delete(
            `${API_URL}/api/banner/offerBanners/${key}`,{
              headers:{
                Authorization:`Bearer ${localStorage.getItem("dashtoken")}`
              }
            }
          );
        })
      );

      setData((prevData) =>
        prevData.filter((item) => !selectedRowKeys.includes(item.key))
      );
      setSelectedRowKeys([]);
    } catch (error) {
      console.error("Error deleting selected banners:", error);
    }
  };

  return (
    <section className="section-main top-gap" style={{ marginLeft: "18%" }}>
      <Container>
        <h2 className="head-txt">Offers Banner</h2>
        <div className="select-combine justify-content-end pt-lg-4">
          <Link to="/add-offers-banner/offerBanners">
            <Button className="btn-1">Add New</Button>
          </Link>
          <Button
            className="btn-1"
            onClick={handleDeleteSelectedBanners}
            disabled={selectedRowKeys.length === 0}
          >
            Delete
          </Button>
        </div>

        <div className="pt-4">
          <Table<DataType>
            className="custom-table"
            rowSelection={rowSelection}
            columns={columns}
            dataSource={data}
            loading={loading}
          />
        </div>
      </Container>
    </section>
  );
};

export default OfferBannerMain;
